import { AuthFetchWithResponse } from 'src/Types/api'
import { StatusCodes } from '@e3dc-react/shell/Libs'
import { ApiResult } from 'src/Libs/api'
import { handleFetchError } from 'src/Libs/api/utils'
import { signalDownload } from 'src/Libs/documents/functions'
import { NdaLanguage, NdaLinkResponse } from '../models/nda.model'
import {
  comparePortalVersions,
  getWebviewPortalVersion,
  handleReactNativeFileDownloadFromUrl,
  VersionComparison,
} from '@e3dc-react/shell/Libs/webview'

export const PORTAL_VERSION_FOR_OLD_REACT_NATIVE_DOWNLOAD = '1.0.6'

const stringifyError = (error: Error): string => {
  return JSON.stringify({
    name: error.name,
    message: error.message,
    stack: error.stack,
  })
}

/**
 * Submit NDA for the selected company
 * @param ndaData
 * @param authFetch
 */
export const submitNda = async (companyId: number, authFetch: AuthFetchWithResponse, log?: (value: string) => void): Promise<ApiResult<string>> => {
  try {
    const response = await authFetch<string>({
      path: `users/non-disclosure-agreements/${companyId}`,
      method: 'POST',
      payload: {},
    })

    if (response.status === StatusCodes.CREATED) {
      return new ApiResult<string>(response.data, false)
    }

    if (companyId) log?.(`submitNda. companyId: ${companyId}, response: ${JSON.stringify(response)}`)

    return new ApiResult<string>(null, true)
  } catch (error) {
    if (companyId) log?.(`submitNda-error. companyId: ${companyId}, error: ${stringifyError(error as Error)}`)
    return handleFetchError<string>(error)
  }
}

/**
 * Fetch link to download NDA file in given language
 * @param companyId
 * @param authFetch
 * @param language
 */
export const fetchNdaFileLink = async (
  companyId: number,
  authFetch: AuthFetchWithResponse,
  language: NdaLanguage = 'de'
): Promise<ApiResult<NdaLinkResponse>> => {
  try {
    const response = await authFetch<NdaLinkResponse>({
      path: `users/non-disclosure-agreements/${companyId}/${language}`,
      method: 'GET',
    })
    if (response.status === StatusCodes.OK) {
      return new ApiResult<NdaLinkResponse>(response.data, false)
    }
    return new ApiResult<NdaLinkResponse>(null, true)
  } catch (error) {
    return handleFetchError<NdaLinkResponse>(error)
  }
}

/**
 * Trigger actual download for the given link
 * @param fileUrl
 * @param companyName
 */
export const downloadNdaFile = (fileUrl: string, companyName: string, isWebview: boolean): void => {
  const webViewPortalVersion = getWebviewPortalVersion()

  if (
    isWebview &&
    webViewPortalVersion &&
    comparePortalVersions(webViewPortalVersion, PORTAL_VERSION_FOR_OLD_REACT_NATIVE_DOWNLOAD) === VersionComparison.Greater
  ) {
    handleReactNativeFileDownloadFromUrl(fileUrl, `${companyName}-nda`, 'pdf', 'application/pdf')
  } else {
    signalDownload(fileUrl, `${companyName}-nda.pdf`, true)
  }
}
